import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'Onze keuze',
  bestPriceBadge: 'Beste prijs',
};
